import React from 'react';
import { FormControl } from '@mui/material';

import dayjs, { Dayjs } from 'dayjs';

import { StyledTimePicker } from 'components/Input/styles';

import { parseTzFreeTime } from 'utils/formatters/timezone';

import { TZ_FREE_TIME_FORMAT, tzFreeAnswer } from '../utils';
import { ProtectorTypeTimeProps } from '../types';
import CustomActionBar from '../CustomPickerActionBar/CustomPickerActionBar';

export const CustomTimePicker = ({
  value,
  onChange,
  requiredNotFilled,
  errorMessage,
  size,
  tzFree,
  timezone,
}: ProtectorTypeTimeProps): React.ReactElement => {
  const [val, setValue] = React.useState<Dayjs | null>(() => {
    if (!value) {
      return null;
    }
    return tzFree && typeof value === 'string' ? parseTzFreeTime(value) : dayjs(value as string);
  });

  const handleChange = (newValue: Dayjs | null): void => {
    if (newValue && Object.prototype.toString.call(newValue) === '[object Object]') {
      if (Number.isNaN(newValue)) {
        return;
      }
      setValue(newValue);
      onChange(tzFreeAnswer(newValue, TZ_FREE_TIME_FORMAT, tzFree));
    } else {
      setValue(null);
      onChange(null);
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const commonTimeProps = {
    value: val,
    format: 'HH:mm',
    slots: {
      actionBar: () => <CustomActionBar actions={['accept']} onAccept={() => handleClose()} />,
    },
    slotProps: {
      textField: {
        size: 'small',
        helperText: errorMessage,
        placeholder: 'hh:mm',
        error: requiredNotFilled,
      },
    },
    sx: {
      '& + .MuiTypography-root': {
        fontSize: '12px',
      },
    },
    onChange: (date: Dayjs | null) => handleChange(date),
    ampm: false,
  };

  return (
    <FormControl fullWidth>
      <StyledTimePicker
        {...commonTimeProps}
        timezone={tzFree ? undefined : timezone}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        slotProps={{
          textField: {
            ...commonTimeProps.slotProps.textField,
            size: size || ('small' as const),
          },
          field: { clearable: true },
        }}
      />
    </FormControl>
  );
};

export default CustomTimePicker;
